import { useEffect, useState } from "react";
import { HoldTight, TSLogo } from "../../images";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Stack from "@vapor/react-material/Stack";
import { useTranslation } from "../../service-i18n";

export const DefaultLoadingView = ({ loading, showAfter, showFor }) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation("react-sdk");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
      clearTimeout(timeout);
    }, showAfter);

    return () => clearTimeout(timeout);
  }, [show]);

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => {
        setShow(false);
        clearTimeout(timeout);
      }, showFor);
    }
  }, [loading]);

  if (!show) return null;

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ p: "32px", gap: "32px", flex: "1" }}
    >
      <TSLogo />
      <HoldTight />
      <ExtendedTypography
        variant="display"
        gutterBottom
        component="div"
        color="primary.textTitleColor"
      >
        {t("default_hold_tight")}
      </ExtendedTypography>
      <ExtendedTypography variant="titleMedium" color="primary.textTitleColor">
        {t("default_application_loading")}
      </ExtendedTypography>
    </Stack>
  );
};
